import { gql } from 'graphql-request';
import useSWR from 'swr';

import fetcher from './fetcher';

const query = gql`
  {
    memberships {
      id
      name
      price
    }
  }
`;

export default function useMemberships() {
  return useSWR(query, fetcher);
}
